import type { IconProps } from '../../types/icon-props';

export const NoResult = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width="121"
      height="120"
      viewBox="0 0 121 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g clip-path="url(#clip0_2017_26149)">
        <path
          d="M56.0061 78.643L6.14182 95.8569C3.20794 96.8699 3.20794 101.019 6.14182 102.032L56.0061 119.246C58.9181 120.251 62.083 120.251 64.995 119.246L114.859 102.032C117.793 101.019 117.793 96.8696 114.859 95.8569L64.995 78.643C62.083 77.6379 58.9181 77.6379 56.0061 78.643Z"
          fill="url(#paint0_linear_2017_26149)"
        />
        <path
          d="M114.86 95.8569L97.7792 89.9604L34.4766 111.813L56.0064 119.246C58.9185 120.251 62.0834 120.251 64.9954 119.246L114.86 102.032C117.794 101.019 117.794 96.8699 114.86 95.8569Z"
          fill="url(#paint1_linear_2017_26149)"
        />
        <path
          d="M6.14182 95.8569L23.2223 89.9604L86.5249 111.813L64.995 119.246C62.083 120.251 58.9181 120.251 56.0061 119.246L6.14182 102.032C3.20794 101.019 3.20794 96.8699 6.14182 95.8569Z"
          fill="url(#paint2_linear_2017_26149)"
        />
        <path
          d="M114.862 102.032L64.9965 119.246C62.0846 120.251 58.9198 120.251 56.008 119.246L50.3725 117.301L30.9795 97.9078C29.4428 96.749 28.7449 94.1289 29.4631 91.8264L30.8663 87.3221L56.0082 78.6435C58.9201 77.6384 62.0849 77.6384 64.9967 78.6435L114.862 95.8572C117.794 96.8699 117.794 101.019 114.862 102.032Z"
          fill="url(#paint3_linear_2017_26149)"
        />
        <path
          d="M60.5015 103.314C76.1418 103.314 85.1135 100.336 89.4956 98.2369C91.3954 97.3268 92.3361 94.38 91.5408 91.8266L88.4754 81.9873L83.3429 72.7908L81.8597 60.7527L77.8269 47.8092L72.0905 36.7409L71.03 25.9925L63.8933 3.08563C62.6114 -1.02919 58.3924 -1.02919 57.1105 3.08563L49.9738 25.9925L48.746 37.4183L43.1768 47.8092L39.1441 60.7527L37.8295 71.6739L32.5286 81.987L29.4632 91.8263C28.6676 94.3795 29.6086 97.3266 31.5084 98.2367C35.8895 100.336 44.8613 103.314 60.5015 103.314Z"
          fill="url(#paint4_linear_2017_26149)"
        />
        <path
          d="M88.4751 81.9875C88.3801 82.0176 88.2831 82.043 88.1859 82.063C80.0318 83.8214 70.5803 84.8292 60.5012 84.8292C50.4222 84.8292 40.9706 83.8214 32.8165 82.063C32.7189 82.0427 32.6224 82.0175 32.5273 81.9875L39.1429 60.7529C45.7184 61.7833 52.933 62.3527 60.5012 62.3527C68.0695 62.3527 75.2841 61.7833 81.8596 60.7529L88.4751 81.9875Z"
          fill="url(#paint5_linear_2017_26149)"
        />
        <path
          d="M77.828 47.8094C72.3748 48.4821 66.5525 48.8447 60.5019 48.8447C54.4513 48.8447 48.6292 48.4819 43.1758 47.8094L49.9739 25.9929C53.3824 26.2397 56.9031 26.3682 60.5019 26.3682C64.1007 26.3682 67.6214 26.2397 71.0299 25.9929L77.828 47.8094Z"
          fill="url(#paint6_linear_2017_26149)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_2017_26149"
          x1="53.6444"
          y1="81.0487"
          x2="73.2729"
          y2="132.282"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF7044" />
          <stop offset="1" stop-color="#F82814" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2017_26149"
          x1="77.1577"
          y1="108.868"
          x2="78.7843"
          y2="113.304"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F82814" stop-opacity="0" />
          <stop offset="0.625" stop-color="#D22725" stop-opacity="0.625" />
          <stop offset="1" stop-color="#C0272D" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2017_26149"
          x1="43.8437"
          y1="108.868"
          x2="42.2171"
          y2="113.304"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F82814" stop-opacity="0" />
          <stop offset="0.625" stop-color="#D22725" stop-opacity="0.625" />
          <stop offset="1" stop-color="#C0272D" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_2017_26149"
          x1="84.3774"
          y1="116.88"
          x2="61.9565"
          y2="76.6988"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F82814" stop-opacity="0" />
          <stop offset="0.625" stop-color="#D22725" stop-opacity="0.625" />
          <stop offset="1" stop-color="#C0272D" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_2017_26149"
          x1="46.6164"
          y1="51.6569"
          x2="87.3069"
          y2="51.6569"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF7044" />
          <stop offset="1" stop-color="#F82814" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_2017_26149"
          x1="50.0398"
          y1="72.7913"
          x2="70.6184"
          y2="72.7913"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F8F6FB" />
          <stop offset="1" stop-color="#EFDCFB" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_2017_26149"
          x1="50.0405"
          y1="37.4188"
          x2="70.6191"
          y2="37.4188"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F8F6FB" />
          <stop offset="1" stop-color="#EFDCFB" />
        </linearGradient>
        <clipPath id="clip0_2017_26149">
          <rect width="120" height="120" fill="white" transform="translate(0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};

NoResult.displayName = 'NoResult';
